import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetricsBrilliance = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "m24 6.247 12.553 5.2L41.753 24l-5.2 12.553L24 41.753l-12.553-5.199L6.247 24l5.2-12.553zM24 3 9.151 9.151 3 24l6.151 14.85L24 45l14.849-6.15L45 24 38.849 9.151z" }), /* @__PURE__ */ _jsx("path", { d: "M38.849 9.151 24 3v42l14.849-6.15L45 24z" })] }) })
});
export default SvgMetricsBrilliance;
